
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loans",
      function () {
        return require("private-next-pages/loans.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loans"])
      });
    }
  